import { authorizeInstance } from 'src/configs/axios.config';

const MODULE = "authorize";

export const login = (data, configs = {}) => authorizeInstance.post(`/v1/${MODULE}/password`, data, configs);

export const logout = (configs = {}) => authorizeInstance.post(`/v1/${MODULE}/logout`, undefined, configs);

export const getNewToken = (configs = {}) => authorizeInstance.post(`/v1/${MODULE}/refresh_token`, undefined, configs);